// Imports
import React from 'react';
import styled from 'styled-components/macro';


// Styled components
const Container = styled.footer`
	width: 80%;
	max-width: 28.125rem;
	margin: 0.75em auto 0;
	padding: 1rem 0 3rem;
	text-align: center;
	font-size: 0.72em;
	line-height: 1.3;
	color: #aaa;
`;


// Function component
const Footer: React.FC = () => <Container>This site is protected by reCAPTCHA.</Container>;

export default Footer;
